import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import Step1BasicInfo from "./steps/Step1BasicInfo";
import Step2ContactDetails from "./steps/Step2ContactDetails";
import Step3Industries from "./steps/Step3Industries";
import Step4Documents from "./steps/Step4Documents";
import Step5Summary from "./steps/Step5Summary";
import { Button } from "antd";
import { CALL_API_UPDATED } from "../../../common/API";
import { useHistory } from "react-router-dom";
import { useSimpleFetch } from "../../../hooks/useSimpleFetch";
import queryKeys from "../../../common/queryKey";
import { useParams } from "react-router-dom";
import { useScrollFetch } from "../../../hooks/useScrollFetch";

const AddClientParent = () => {
    const methods = useForm({
        mode: "onChange",
        shouldUnregister: false,
    });

    const { trigger, reset } = methods;


    const history = useHistory();

    const clientId = window.location.pathname.split("/").pop();
    const isEditMode = Boolean(clientId && clientId !== "add-client");
    const {
        getClientIdCount, getClient
    } = queryKeys;


    const { data: clientIdCount } = useSimpleFetch(
        getClientIdCount().key,
        getClientIdCount().url
    );
    const {
        data: clientDetailsPages,
        isLoading: isEditLoading,
    } = useScrollFetch(
        isEditMode ? getClient(clientId).key : null,
        isEditMode
            ? {
                endPoint: getClient(clientId).url,
            }
            : null,
        {
            enabled: isEditMode,
            getNextPageParam: () => null,
        }
    );


    const clientDetails =
        clientDetailsPages?.pages?.[0]?.response?.client ?? null;

    useEffect(() => {
        if (!clientDetails) return;

        reset({
            clientId: clientDetails.bdo_id, // 🔥 IMPORTANT

            relationshipType:
                clientDetails[
                "bdo_businessrelationship@OData.Community.Display.V1.FormattedValue"
                ],

            engagement:
                clientDetails[
                "bdo_currentyearofengagement@OData.Community.Display.V1.FormattedValue"
                ],

            influential:
                clientDetails[
                "bdo_influentialstarcustomer@OData.Community.Display.V1.FormattedValue"
                ],

            managingOffice:
                clientDetails[
                "bdo_managingoffice@OData.Community.Display.V1.FormattedValue"
                ],

            bcClientId: clientDetails.bdo_bcclientid,

            riskClassification:
                clientDetails[
                "bdo_riskclassification@OData.Community.Display.V1.FormattedValue"
                ],

            reviewCyclePeriod:
                clientDetails[
                "bdo_reviewcycleperiod@OData.Community.Display.V1.FormattedValue"
                ],

            status: clientDetails.status_id,

            createdDate: clientDetails.bdo_createddate,
            archiveDate: clientDetails.bdo_removalarchivedate,
            archiveReason: clientDetails.bdo_removalarchivereason,

            strategicPartner:
                clientDetails[
                "bdo_strategicpartner@OData.Community.Display.V1.FormattedValue"
                ],

            loginOfficeEmail: clientDetails.login_officeEmail,
            loginPassword: clientDetails.login_password,
            companyName: clientDetails.name,
            officeEmail: clientDetails?.login_officeEmail,
            owner:
                clientDetails[
                "_ownerid_value@OData.Community.Display.V1.FormattedValue"
                ],
            size: clientDetails?.otherInfoSize,
            websiteURL: clientDetails?.websiteurl,
            incorporationType: clientDetails[
                "bdo_incorporationtype@OData.Community.Display.V1.FormattedValue"
            ],
            primarySector: clientDetails[
                "_bdo_sector_value@OData.Community.Display.V1.FormattedValue"
            ],
            primaryIndustry: clientDetails[
                "_bdo_primaryindustry_value@OData.Community.Display.V1.FormattedValue"],
            primaryContactEmail: clientDetails.emailaddress2,
            primaryContactPerson: clientDetails[
                "_primarycontactid_value@OData.Community.Display.V1.FormattedValue"],
            description: clientDetails.description,
            addressType: clientDetails?.bdo_addresstype,
            registeredAddress: clientDetails?.bdo_registeredaddress,
            country: clientDetails?.country,
            registeredNo: clientDetails?.bdo_registrationno,
            registeredOfficePostalAddress: clientDetails?.address1_line1,
            useGroupAddress: clientDetails?.bdo_usegroupaddress,
            city: clientDetails?.address1_city,
            operatingCountries: clientDetails?.bdo_operatingcountries,
            pinNo: clientDetails?.bdo_pin,
            postalCode: clientDetails?.bdo_postalcode,
            liaisonManager:
                clientDetails[
                "_bdo_relationship_value@OData.Community.Display.V1.FormattedValue"
                ],

            liaisonManagerRole:
                clientDetails[
                "bdo_relationshipliaisonmanagersrole@OData.Community.Display.V1.FormattedValue"
                ],

            aliasName: clientDetails?.bdo_othersideentitynamealiasname,

            classificationType:
                clientDetails[
                "bdo_classificationtype@OData.Community.Display.V1.FormattedValue"
                ],

            secretory: clientDetails?.bdo_secretory,

            liaisonEmail:
                clientDetails?.relationshipliaisonmanagererelationshipliaisonmanageremailmai,

            liaisonId:
                clientDetails[
                "_primarycontactid_value@OData.Community.Display.V1.FormattedValue"
                ],

            entityType:
                clientDetails[
                "bdo_entitytype@OData.Community.Display.V1.FormattedValue"
                ],

            principleLawyer: clientDetails?.bdo_principlelawyer,

            principleBanker: clientDetails?.bdo_principlebanker,

            /* ---------------- OTHER INFORMATION ---------------- */

            bcClientId: clientDetails?.bdo_bcclientid,

            riskClassification:
                clientDetails[
                "bdo_riskclassification@OData.Community.Display.V1.FormattedValue"
                ],

            reviewCyclePeriod:
                clientDetails[
                "bdo_reviewcycleperiod@OData.Community.Display.V1.FormattedValue"
                ],

            status: clientDetails["statecode@OData.Community.Display.V1.FormattedValue"]
                ? clientDetails["statecode@OData.Community.Display.V1.FormattedValue"] === "Active"
                    ? "Active"
                    : "Inactive"
                : "",

            sizeMarketing:
                clientDetails["bdo_size@OData.Community.Display.V1.FormattedValue"],

            domicile:
                clientDetails["_bdo_domicile_value@OData.Community.Display.V1.FormattedValue"],

            typeOfPIE: clientDetails?.bdo_typeofpie,

            reviewDueDate: clientDetails?.bdo_reviewduedate,

            reviewCountryIncorp:
                clientDetails[
                "_bdo_domicile_value@OData.Community.Display.V1.FormattedValue"
                ],

            publicInterestEntity:
                clientDetails[
                "bdo_publicinterestentity@OData.Community.Display.V1.FormattedValue"
                ],

            regulator:
                clientDetails[
                "bdo_regulator@OData.Community.Display.V1.FormattedValue"
                ],

            /* ---------------- MARKETING ---------------- */

            lastDateCampaign: clientDetails?.bdo_date,

            sendMarketingMaterials:
                clientDetails["donotsendmm@OData.Community.Display.V1.FormattedValue"],

            /* ---------------- BUSINESS RELATIONSHIP ---------------- */

            businessRelationship:
                clientDetails[
                "bdo_businessrelationship@OData.Community.Display.V1.FormattedValue"
                ],

            brFlagValue:
                clientDetails[
                "bdo_br_flag_value@OData.Community.Display.V1.FormattedValue"
                ],

            designationTemplate:
                clientDetails[
                "bdo_designationtemplate@OData.Community.Display.V1.FormattedValue"
                ],

            createdDate: clientDetails?.bdo_createddate,

            archiveReason: clientDetails?.bdo_removalarchivereason,

            strategicPartner:
                clientDetails[
                "bdo_strategicpartner@OData.Community.Display.V1.FormattedValue"
                ],

            businessDesignationType:
                clientDetails[
                "bdo_businessdesignationtype@OData.Community.Display.V1.FormattedValue"
                ],

            designationLevel:
                clientDetails[
                "bdo_designationlevellocation_hierarchy@OData.Community.Display.V1.FormattedValue"
                ],

            archiveDate: clientDetails?.bdo_removalarchivedate,

            reference: clientDetails?.bdo_referenceoptional,
            /* -------- Eligibility & Independence -------- */
            eligibleFirm:
                clientDetails[
                "bdo_thefirmisqualifiedandiseligibleinca@OData.Community.Display.V1.FormattedValue"
                ],

            complianceRules:
                clientDetails[
                "bdo_firmsrulesandproceduresasdescribedintheb@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Prospective Client’s Reputation -------- */
            referredDiscussion:
                clientDetails[
                "bdo_discusswithreferrersasdescribedintheb@OData.Community.Display.V1.FormattedValue"
                ],

            financialReview:
                clientDetails[
                "bdo_theprospectiveclientsfs@OData.Community.Display.V1.FormattedValue"
                ],

            referredDiscussionAgain:
                clientDetails[
                "bdo_theprospectiveclientwithpartnersandmanage@OData.Community.Display.V1.FormattedValue"
                ],

            financialReviewAgain:
                clientDetails?.bdo_iftheaboveproceduresareinconclusivecontac,

            /* -------- International Referrals -------- */
            discussedWithParentPartner:
                clientDetails[
                "bdo_prospectiveclientsreputation@OData.Community.Display.V1.FormattedValue"
                ],

            discussedWithInternationalPartner:
                clientDetails[
                "bdo_internationallaisonpartner@OData.Community.Display.V1.FormattedValue"
                ],

            otherFirmProcedures:
                clientDetails[
                "bdo_othermemberfirmsacceptanceprocedurescon@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Previous Auditors -------- */
            authorizePreviousAuditors:
                clientDetails[
                "bdo_theprospectiveclienttoauthorizethepreviou@OData.Community.Display.V1.FormattedValue"
                ],

            previousAuditorsDecision:
                clientDetails[
                "bdo_thepreviousauditortodeterminifthereisanyreason@OData.Community.Display.V1.FormattedValue"
                ],

            contactPreviousAuditor:
                clientDetails[
                "bdo_contactwithpreviousauditortodiscussmatte@OData.Community.Display.V1.FormattedValue"
                ],

            changingAuditorsReason:
                clientDetails[
                "bdo_heprospectiveclient@OData.Community.Display.V1.FormattedValue"
                ],

            accessAuditorWorkingPapers:
                clientDetails[
                "bdo_thepreviousauditorsworkingpapersasrelevan@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Ability to Serve -------- */
            staffAvailability:
                clientDetails[
                "bdo_appropriatepartnersandstaffareavailableto@OData.Community.Display.V1.FormattedValue"
                ],

            specialistExpertise:
                clientDetails[
                "bdo_firmhasorcanobtainanyspecialistexpertise@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Fees -------- */
            feeBasis:
                clientDetails[
                "bdo_theagreedprincipalbasisonwhichthefeesshal@OData.Community.Display.V1.FormattedValue"
                ],

            independentFeeArrangement:
                clientDetails[
                "bdo_firmindependentwithrespecttotheclientrega@OData.Community.Display.V1.FormattedValue"
                ],

            proBonoRationale:
                clientDetails[
                "bdo_incaseofaprobonoengagement@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Industry Background & Risk -------- */
            industryBackground:
                clientDetails[
                "bdo_clientstypeofbusinessandbriefdetailsabout@OData.Community.Display.V1.FormattedValue"
                ],

            negativeConcernsMarket:
                clientDetails[
                "bdo_arethereanynegativeconcernsabouttheprospe@OData.Community.Display.V1.FormattedValue"
                ],

            publicHeld:
                clientDetails[
                "bdo_listedonastockexchange@OData.Community.Display.V1.FormattedValue"
                ],

            managementAttitude:
                clientDetails[
                "bdo_managementsattitudetocontrolsystemsitspla@OData.Community.Display.V1.FormattedValue"
                ],

            accountingCompetence:
                clientDetails[
                "bdo_theapparentcompetenceofaccountingfinancia@OData.Community.Display.V1.FormattedValue"
                ],

            crimeConviction:
                clientDetails[
                "bdo_hastheprospectiveclientoranyofitsdirector@OData.Community.Display.V1.FormattedValue"
                ],

            abilityContinue:
                clientDetails[
                "bdo_istheresubstantialdoubtconcerningtheprosp@OData.Community.Display.V1.FormattedValue"
                ],

            continuityManagement:
                clientDetails[
                "bdo_recentcontinuityofmanagementanditsperceiv@OData.Community.Display.V1.FormattedValue"
                ],

            financialNeedsCompany:
                clientDetails[
                "bdo_thefinancialneedsofthecompanyanditsabilit@OData.Community.Display.V1.FormattedValue"
                ],

            growthSource:
                clientDetails[
                "bdo_therapidityofgrowthinrecentyearsandtheso@OData.Community.Display.V1.FormattedValue"
                ],

            characterIntegrity:
                clientDetails[
                "bdo_hastheprospectiveclientscharacterintegrit@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Independence Checks -------- */
            noLitigation:
                clientDetails[
                "bdo_arewesatisfiedthatthereisnolitigationtaki@OData.Community.Display.V1.FormattedValue"
                ],

            noFamilyConnections:
                clientDetails[
                "bdo_canweconfirmthatnopartnersorstaffengagedi@OData.Community.Display.V1.FormattedValue"
                ],

            confirmPartnerConnections:
                clientDetails[
                "bdo_canweconfirmthatanypartnerorcloselyconnec@OData.Community.Display.V1.FormattedValue"
                ],

            noScopeLimitations:
                clientDetails[
                "bdo_arewesatisfiedthattherearenolimitationsof@OData.Community.Display.V1.FormattedValue"
                ],

            clientBusinessDetails:
                clientDetails[
                "bdo_clientofbusiness@OData.Community.Display.V1.FormattedValue"
                ],

            noOtherImpairments:
                clientDetails[
                "bdo_arewesatisfiedthattherearenootherfactorsw@OData.Community.Display.V1.FormattedValue"
                ],

            noOtherFactorsPeriod:
                clientDetails[
                "bdo_havewesatisfiedourselvesthattherewerenoot@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Risk Rating -------- */
            anticipatingPublicOffering:
                clientDetails[
                "bdo_anticipatingapublicofferingwithinthenextt@OData.Community.Display.V1.FormattedValue"
                ],

            buyoutOrTakeover:
                clientDetails[
                "bdo_couldbesubjectofabuyoutortakeoverwithint@OData.Community.Display.V1.FormattedValue"
                ],

            highTechOrRegulatedIndustry:
                clientDetails[
                "bdo_involvedinhightechemergingorheavilyhighly@OData.Community.Display.V1.FormattedValue"
                ],

            aggressiveAccountingPolicies:
                clientDetails[
                "bdo_aggressiveaccountingpoliciesundueemphasis@OData.Community.Display.V1.FormattedValue"
                ],

            complexAccountingPrinciples:
                clientDetails[
                "bdo_complexaccountingprinciples@OData.Community.Display.V1.FormattedValue"
                ],

            continuingLosses:
                clientDetails[
                "bdo_continuinglossesandorexperiencingliquidit@OData.Community.Display.V1.FormattedValue"
                ],

            unrealisticReportingDeadlines:
                clientDetails[
                "bdo_unrealisticreportingdeadlines@OData.Community.Display.V1.FormattedValue"
                ],

            poorDebtPosition:
                clientDetails[
                "bdo_poordebtposition@OData.Community.Display.V1.FormattedValue"
                ],

            dominatingManagement:
                clientDetails[
                "bdo_domineeringchiefexecutivemanagement@OData.Community.Display.V1.FormattedValue"
                ],

            weakInternalControls:
                clientDetails[
                "bdo_weakinternalcontrolsandpoormanagement@OData.Community.Display.V1.FormattedValue"
                ],

            offshoreTaxHavens:
                clientDetails[
                "bdo_engagesinoffshoretransactionsintaxhavenso@OData.Community.Display.V1.FormattedValue"
                ],

            foreignSubsidiaries:
                clientDetails[
                "bdo_hasforeignsubsidiariesaffiliates@OData.Community.Display.V1.FormattedValue"
                ],

            reputationSullied:
                clientDetails[
                "bdo_clientmanagementreputationsullied@OData.Community.Display.V1.FormattedValue"
                ],

            predecessorAuditIssues:
                clientDetails[
                "bdo_disputesunresolvedissueswithpredecessorau@OData.Community.Display.V1.FormattedValue"
                ],

            evasiveOrAbusiveBehavior:
                clientDetails[
                "bdo_isevasiveorabusivetobdoeastafricastaffdur@OData.Community.Display.V1.FormattedValue"
                ],

            /* -------- Conclusion -------- */
            liaisonConclusion:
                clientDetails[
                "_bdo_relationship_value@OData.Community.Display.V1.FormattedValue"
                ],

            signature: clientDetails?.conclusionSignature,

            conclusionDate: clientDetails?.conclusionDate,

            /* -------- Conclusion Approval -------- */
            liaisonManagerApproval:
                clientDetails[
                "_bdo_relationship_value@OData.Community.Display.V1.FormattedValue"
                ],

            signatureApproval: clientDetails?.conclusionSignature,

            approvalDate: clientDetails?.conclusionDate,

            /* -------- Final Acceptance -------- */
            acceptanceCompleted:
                clientDetails[
                "bdo_onboarded@OData.Community.Display.V1.FormattedValue"
                ],

            clientOnboarded:
                clientDetails[
                "bdo_coicheckpassed@OData.Community.Display.V1.FormattedValue"
                ],
            loginOfficeEmail: clientDetails?.login_officeEmail,
            loginPassword: clientDetails?.login_password,
        });
    }, [clientDetails, reset]);


    const [step, setStep] = useState(1);

    const next = async () => {
        let fields = [];

        if (step === 1) {
            fields = [
                "relationshipType",
                "engagement",
                "influential",
                "managingOffice",
                "primaryContactEmail",
                "primaryContactPerson"
            ];
        }

        if (step === 2) {
            fields = [
                // Other Information
                "bcClientId",
                "riskClassification",
                "reviewCyclePeriod",
                "status",

                // Marketing
                "lastDateCampaign",

                // Business Relationship
                "businessRelationship",
                "brFlagValue",
                "designationTemplate",
                "createdDate",
                "archiveReason",
                "strategicPartner",
                "businessDesignationType",
                "designationLevel",
                "archiveDate",
            ];
        }
        // STEP 5 (Login Credentials)
        if (step === 5) {
            fields = [
                "loginOfficeEmail",
                "loginPassword",
            ];
        }


        const isValid = await trigger(fields, { shouldFocus: true });

        if (isValid) {
            setStep((prev) => prev + 1);
        }
    };


    const prev = () => setStep((prev) => prev - 1);


    const onSubmit = async (data) => {
        console.log("Final Data => ", data);

        const payload = {
            clientId: data.clientId,
            influentialstarCustomer: data?.influential,
            relationshipType: data?.relationshipType,
            currentNatureofEngag: data.engagement || "Ongoing",
            companyRegisteredName: data.companyName,
            owner: data.owner,
            size: data.size,
            countryofIncorporation: data.countryIncorp,
            managingOffice: data.managingOffice,
            emailaddress: data.officeEmail,
            incorporationType: data.incorporationType,
            companyWebsiteUrl: data.websiteURL,
            primaryIndustry: data.primaryIndustry,
            primarySector: data?.primarySector,
            primaryContactPerson: data.primaryContactPerson,
            primaryContactEmail: data.primaryContactEmail,
            description: data.description,
            //Address
            bdoAddresstype: data.addressType,
            bdoUsegroupaddress: data.useGroupAddress,
            bdoRegisteredaddress: data.registeredAddress,
            address1City: data.city,
            country: data.country,
            bdoOperatingcountries: data.operatingCountries,
            bdoRegistrationno: data.registeredNo,
            bdoPin: data.pinNo,
            officepostalAddress: data.registeredOfficePostalAddress,
            bdoPostalcode: data.postalCode,

            //Relationship
            relationshipManagerEmail: data.liaisonEmail,
            relationshipManagerRole: data.liaisonManagerRole,
            otherSideEntityAliasName: data.aliasName,
            entityType: data.entityType,
            classificationType: data.classificationType,
            principleLawyer: data.principleLawyer,
            secretory: data.secretory,
            principleBanker: data.principleBanker,

            //other information
            bcClientId: data.bcClientId,
            riskClassification: data.riskClassification,
            reviewCyclePeriod: data.reviewCyclePeriod,
            reviewDueDate: data.reviewDueDate,
            status: data.status,
            otherInfoSize: data?.sizeMarketing,
            domicile: data.domicile,
            publicInterestEntity: data.publicInterestEntity === "Yes" ? true : false,
            typeOfPie: data.typeOfPIE,
            regulator: data.regulator,

            //marketing
            lastusedincampaign: data?.lastDateCampaign,
            sendMarketingMaterials: data?.sendMarketingMaterials,

            //Business Relationship
            businessRelationship: data.businessRelationship,
            strategicPartner: data.strategicPartner,
            brFlagValue: data.brFlagValue,
            businessDesignationType: data.businessDesignationType,
            designationTemplate: data.designationTemplate,
            designationLevelLocationHierarchy: data.designationLevel,
            createdDate: data.createdDate,
            removalArchiveDate: data.archiveDate,
            removalArchiveReason: data.archiveReason,
            reference: data?.reference,

            //Eligibility & Independence
            ensureFirmQualified: data.eligibleFirm,
            ensureFirmCompliesWithRules: data.complianceRules,

            //The Prospective Client’s Reputation
            discussWithReferrer: data.referredDiscussion,
            reviewProspectiveClientFinancials: data.financialReview,
            discussWithPartnersManagers: data?.referredDiscussionAgain,
            inconclusiveContactFriends: data?.financialReviewAgain,
            //incase of internal referral
            parentEnagaementPartner: data?.discussedWithParentPartner,
            discussedWithInternationalPartner: data?.discussedWithInternationalPartner,
            memberFirmAcceptanceProcedures: data.otherFirmProcedures,

            //previous auditor,
            authorizePreviousAuditor: data.authorizePreviousAuditors,
            previousAuditorsDecision: data.previousAuditorsDecision,
            contactPreviousAuditor: data.contactPreviousAuditor,
            prospectiveClientCompanyChangingAuditors: data?.changingAuditorsReason,
            previousAuditorsWorkingPapers: data?.accessAuditorWorkingPapers,

            //Ability to serve the client is the firm able to comply with the following
            appropriatePartnersAvailable: data?.staffAvailability,
            specialistExpertise: data?.specialistExpertise,
            feeBasis: data?.feeBasis,
            firmIndependent: data?.independentFeeArrangement,
            proBonoRationale: data?.proBonoRationale,

            //Investigation of industry background & clients
            clientsTypeOfBusiness: data.industryBackground,
            negativeConcerns: data.negativeConcernsMarket,
            publiclyHeld: data?.publiclyHeld,
            managementAttitude: data.managementAttitude,
            competenceOfPersonnel: data.accountingCompetence,
            convictedOfCrime: data?.crimeConviction,
            doubtOfExistence: data?.abilityContinue,
            continuityOfManagement: data.continuityManagement,
            financialNeeds: data?.financialNeedsCompany,
            rapidGrowth: data?.growthSource,
            characterIntegrity: data.characterIntegrity,

            //litigation
            noLitigation: data?.noLitigation,
            noFamilyConnections: data?.noFamilyConnections,
            confirmPartnerConnections: data?.confirmPartnerConnections,
            noScopeLimitations: data?.noScopeLimitations,
            clientBusinessDetails: data?.clientBusinessDetails,
            noOtherImpairments: data?.noOtherImpairments,
            noOtherFactorsPeriod: data?.noOtherFactorsPeriod,

            //risk
            listedOnStockExchange: data?.listedOnStockExchange,
            anticipatingPublicOffering: data?.anticipatingPublicOffering,
            subjectToBuyoutOrTakeover: data?.buyoutOrTakeover,
            involvedInHighTech: data?.highTechOrRegulatedIndustry,
            otherPublicInterestEntity: data?.publicInterestEntity,
            aggressiveAccountingPolicies: data?.aggressiveAccountingPolicies,
            complexAccountingPrinciples: data?.complexAccountingPrinciples,
            continuingLosses: data?.continuingLosses,
            unrealisticReportingDeadlines: data?.unrealisticReportingDeadlines,
            poorDebtPosition: data?.poorDebtPosition,
            domineeringManagement: data?.dominatingManagement,
            weakInternalControls: data?.weakInternalControls,
            offshoreTransactions: data?.offshoreTaxHavens,
            foreignSubsidiaries: data?.foreignSubsidiaries,
            managementReputationSullied: data?.reputationSullied,
            disputesWithPredecessorAuditor: data?.predecessorAuditIssues,
            evasiveOrAbusive: data?.evasiveOrAbusiveBehavior,

            //conslusion
            relationshipManager: data.liaisonManager,
            signature: data.signatureApproval,
            acceptanceDate: data.approvalDate,

            //COI CHECK PROCESS
            localCOI: data.localCOI,
            globalCheck: data.globalCheck,
            worldCheck: data.amlWorldCheck,
            corporateTree: data.corporateTreeRequest,

            //Conclusion: I have perform
            conclusionRelationship: data?.liaisonManagerApproval,
            conclusionSignature: data?.signatureApproval,
            conclusionDate: data.conclusionDate,
            clientOnboarded: data?.acceptanceCompleted,
            clientAcceptanceCompleted: data?.clientOnboarded,

            //credentials
            loginOfficeEmail: data?.loginOfficeEmail,
            loginPassword: data?.loginPassword,

        };
        let response;

        if (isEditMode) {
            // ✅ UPDATE API
            response = await CALL_API_UPDATED(
                `insyts-crm-clients/BDO/${data.clientId}`,
                "patch",
                payload
            );
        } else {
            // ✅ CREATE API
            response = await CALL_API_UPDATED(
                `insyts-crm-clients`,
                "post",
                payload
            );
        }

        if (response?.status === "SUCCESS") {
            history.push("/client");
        }

        if (response?.status === "SUCCESS") {
            history.push("/client");
        }

    };

    return (
        <div style={{ background: "#fff", padding: 30, minHeight: "100vh" }}>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>

                    {/* Breadcrumb & Stepper */}
                    <div style={{ marginBottom: 30 }}>
                        <div style={{ fontSize: 14, color: "#6c757d", marginBottom: 15 }}>
                            <span onClick={() => history.push("/client")} style={{ cursor: "pointer" }}>Client</span> &nbsp; &gt; &nbsp;
                            <span style={{ fontWeight: 600 }}>
                                {isEditMode ? `Editing Client - ${clientDetails?.name}` : "Adding New Client"}
                            </span>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 40,
                            }}
                        >
                            {[1, 2, 3, 4, 5].map((item, index) => (
                                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                                    <div
                                        style={{
                                            width: 55,
                                            height: 55,
                                            borderRadius: "50%",
                                            border: "1.5px solid #B8B8B8",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: step === item ? "#E6FAF3" : "#FFFFFF",
                                            color: step === item ? "#000" : "#9AA0A6",
                                            fontWeight: 600,
                                            fontSize: 20,
                                        }}
                                    >
                                        {item}
                                    </div>

                                    {item !== 5 && (
                                        <div
                                            style={{
                                                width: 80,
                                                height: 2,
                                                background: "#DDD",
                                                margin: "0 10px",
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* STEP COMPONENTS */}
                    {step === 1 && <Step1BasicInfo count={clientIdCount?.response?.data?.count} isEditMode={isEditMode} />}
                    {step === 2 && <Step2ContactDetails isEditMode={isEditMode} />}
                    {step === 3 && <Step3Industries />}
                    {step === 4 && <Step4Documents />}
                    {step === 5 && <Step5Summary />}

                    {/* Navigation Buttons */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 30,
                            gap: 12,
                        }}
                    >
                        <Button
                            type="text"
                            onClick={() => history.push("/client")}
                            style={{
                                fontSize: 16,
                                fontWeight: 500,
                                color: "#000",
                                padding: "6px 22px",
                            }}
                        >
                            Cancel
                        </Button>


                        {step > 1 && (
                            <Button
                                onClick={prev}
                                style={{
                                    borderColor: "#000",
                                    color: "#000",
                                    fontWeight: 500,
                                    padding: "6px 22px",
                                    borderRadius: 6,
                                }}
                            >
                                Previous
                            </Button>
                        )}

                        {step < 5 && (
                            <Button
                                type="primary"
                                onClick={next}
                                style={{
                                    background: "#B5F3DA",
                                    color: "#000",
                                    fontWeight: 600,
                                    borderRadius: 6,
                                    padding: "6px 22px",
                                    border: "none",
                                }}
                            >
                                Next
                            </Button>
                        )}

                        {step === 5 && (
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    background: "#B5F3DA",
                                    color: "#000",
                                    fontWeight: 600,
                                    borderRadius: 6,
                                    padding: "6px 22px",
                                    border: "none",
                                }}
                            >
                                {isEditMode ? "Update" : "Complete"}
                            </Button>
                        )}
                    </div>
                </form>
            </FormProvider>
        </div>
    );
};

export default AddClientParent;
